<template>
<div class="adorn-bottom-left pb-5">
    <v-layout row wrap >
        <v-flex xs12 sm9 class="animated fadeInUp dura_1">
          <ui-title-red textTitle="Presupuesto"></ui-title-red>
        </v-flex>
        <v-flex xs12 sm2 md2 class="hidden-xs-only aligner">
          <image-app class="animated fadeInRight" :imaSize="300" imaSrc="design/banco1-1-3-2" imaAlt=""></image-app>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <ui-simple-lsc  :vidTittle="'Presupuesto'" videoEmbed="ADMINISTRACIONDINERO37ValorPlaneadoVSValorReal.mp4"></ui-simple-lsc>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mt-5 class="animated fadeInUp dura_2">
        <v-flex xs12 sm1 hidden-xs-only>
          <image-app class="animated fadeInLeft" :imaSize="80" imaSrc="design/banco3-1-1" imaAlt=""></image-app>
        </v-flex>
        <v-flex xs12 sm6>
          <p>Ahora que ya sabe cuánto gasta en un tema específico, puede determinar cuánto podría gastar
            mensualmente en dicha categoría haciendo una mejor administración de su dinero.
            <br><br>Anote esta cantidad en la columna valor planeado, valor que en muchos casos es igual al
            valor real. Una vez asignada la cantidad para cada categoría observará la diferencia
            entre lo real y lo planeado. Estas son las diferencias entre sus gastos actuales y los planeados.
            <br><br>Para ingresar los valores planeados regrese en el curso hasta el inicio del presupuesto mensual.
          </p>
          <br>
        </v-flex>
      </v-layout>
</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-37.vue?a4b4c064